module.exports = __webpack_public_path__ + "img/Magnuss72.e8965eb4.jpg";